export default __webpack_public_path__ + "static/media/app_store.1dca77f8.svg";